<template>
	<div class="container">
		<div class="">
			<div class="card">
				<div class="card-header">
					<h4 class="card-header-title">
						Payment Summaries
					</h4>
				</div>
				<div class="table-responsive mb-0">
					<table class="table table-sm table-nowrap card-table">
						<thead>
							<tr>
								<th>Date Range</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-if="!summary_periods.length">
								<td
									colspan="2"
									align="center">
									There are no summaries available at this time.
								</td>
							</tr>
							<tr
								v-for="(item, index) in summary_periods"
								:key="index">
								<td>
									<p>{{ item.name }}</p> <p style="font-size: 10px;">
										({{ item.from }} to {{ item.to }})
									</p>
								</td>
								<td>
									<a
										href="#"
										class="btn btn-primary btn-sm"
										@click="downloadSummary(item)">Download <i
											class="fa fa-download"></i></a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: [],
		data() {
			return {
				summary_periods: []
			}
		},
		computed: {
			user() {
				return this.$store.getters['auth/user']
			}
		},
		mounted() {
			this.fetchPaymentSummaries();
		},
		methods: {
			downloadSummary(period) {
				this.$axios.get('/api/payment-summaries/download', {
					params: {
						cleaner_id: this.user.id,
						from: period.from,
						to: period.to,
					},
					responseType: 'blob'
				}).then((response) => {
					const url = window.URL.createObjectURL(new Blob([response.data]))
					const link = document.createElement('a')
					link.href = url
					link.setAttribute('download', 'summary.pdf')
					document.body.appendChild(link)
					link.click()
				}).catch(() => {
					toastr.error('Error downloading payment summary.');
				});
			},
			fetchPaymentSummaries: function () {
				this.$axios.get('/api/payment-summaries', {
					params: {
						cleaner_id: this.user.id,
					}
				}).then((response) => {
					this.summary_periods = response.data;
				}).catch(() => {
					toastr.error('Error loading payments summaries.');
				});
			},
		}
	}
</script>

<style scoped>
	p {
		margin-bottom: 0px;
	}
</style>
